import Cookies from 'js-cookie';
import { fetch_with_auth } from './auth_fetch';

const approve_topic = async (topic, action, uid) => {
    try {
        const url = `/api/${topic}/approve/${uid}`
        const data = {
            action: action,
            uid: Number(uid),
        }
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
                others: {
                    body: JSON.stringify(data)
                }
            }
        )
        if (success) {
            return [result.response.status, null]
        } else {
            return [500, null]
        }
    } catch (error) {
        return [500, null]
    }
}

export const approve_wazaren = async (action, uid) => {
    const result = await approve_topic("wazaren", action, uid);
    return result;
}

export const approve_wotageishi = async (action, uid) => {
    const result = await approve_topic("wotageishi", action, uid);
    return result;
}

export const approve_organization = async (action, uid) => {
    const result = await approve_topic("organization", action, uid);
    return result;
}

export const fetch_statistic = async () => {
    const url = '/api/statistic/approve_topic'
    try {
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
            }
        );
        if (success) {
            const data = await result.response.json();
            return [result.response.status, data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
    
}

const preview_topic = async (topic, temp_id, lang) => {
    const url = `/api/${topic}/request/preview/${temp_id}?lang=${lang}`
    try {
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
            }
        );
        if (success) {
            const data = await result.response.json();
            return [result.response.status, data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const preview_wazaren = async (temp_id, lang) => {
    const result = await preview_topic("wazaren", temp_id, lang);
    return result;
}

export const preview_wotageishi = async (temp_id, lang) => {
    const result = await preview_topic("wotageishi", temp_id, lang);
    return result;
}

export const preview_organization = async (temp_id, lang) => {
    const result = await preview_topic("organization", temp_id, lang);
    return result;
}

const exit_preview_topic = async (topic, temp_id) => {
    const url = `/api/${topic}/request/exit_preview/${temp_id}`
    try {
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
            }
        );
        if (success) {
            const data = await result.response.json();
            return [result.response.status, data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const exit_preview_wazaren = async (temp_id) => {
    const result = await exit_preview_topic("wazaren", temp_id);
    return result;
}

export const exit_preview_wotageishi = async (temp_id) => {
    const result = await exit_preview_topic("wotageishi", temp_id);
    return result;
}

export const exit_preview_organization = async (temp_id) => {
    const result = await exit_preview_topic("organization", temp_id);
    return result;
}

const save_preview_topic = async (topic, temp_id, data) => {
    const url = `/api/${topic}/request/save_preview/${temp_id}`
    try {
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
                others: {
                    body: JSON.stringify(data),
                }
                
            }
        );
        if (success) {
            const data = await result.response.json();
            return [result.response.status, data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const save_preview_wazaren = async (temp_id, data) => {
    const result = await save_preview_topic("wazaren", temp_id, data);
    return result;
}

export const save_preview_wotageishi = async (temp_id, data) => {
    const result = await save_preview_topic("wotageishi", temp_id, data);
    return result;
}

export const save_preview_organization = async (temp_id, data) => {
    const result = await save_preview_topic("organization", temp_id, data);
    return result;
}

const heartbeat_preview_topic = async (topic, temp_id) => {
    const url = `/api/${topic}/request/heartbeat_preview/${temp_id}`
    try {
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
            }
        );
        if (success) {
            const data = await result.response.json();
            return [result.response.status, data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const heartbeat_preview_wazaren = async (temp_id) => {
    const result = await heartbeat_preview_topic("wazaren", temp_id);
    return result;
}

export const heartbeat_preview_wotageishi = async (temp_id) => {
    const result = await heartbeat_preview_topic("wotageishi", temp_id);
    return result;
}

export const heartbeat_preview_organization = async (temp_id) => {
    const result = await heartbeat_preview_topic("organization", temp_id);
    return result;
}
